import Vue from "vue";
import {
  // 全局实例对象
  VXETable,

  // 可选表格模块
  VxeTableFilterModule,
  VxeTableEditModule,
  // VxeTableMenuModule,
  // VxeTableExportModule,
  VxeTableKeyboardModule,
  // VxeTableValidatorModule,
  VxeTableCustomModule,

  // 可选组件
  VxeIcon,
  VxeTable,
  VxeColumn,
  // VxeColgroup,
  VxeGrid,
  VxeTooltip,
  VxeToolbar,
  VxePager,
  // VxeForm,
  // VxeFormItem,
  // VxeFormGather,
  VxeCheckbox,
  VxeCheckboxGroup,
  VxeRadio,
  // VxeRadioGroup,
  // VxeRadioButton,
  VxeSwitch,
  VxeInput,
  VxeSelect,
  // VxeOptgroup,
  // VxeOption,
  // VxeTextarea,
  VxeButton,
  // VxeButtonGroup,
  // VxeModal,
  VxeList,
  // VxePulldown,
} from "vxe-table";
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
import "@/assets/styles/vxetable-variables.scss";
import { phoneFilter, IDCardFilter } from "@/utils/tools";
import { hasOwn } from "element-ui/src/utils/util";
import {downloadFile} from "@/api/publicApi"
VXETable.setConfig({
  size: "medium",
  // loadingText: "加载中...", // 全局loading提示内容，如果为null则不显示文本
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args),
});

import VXETablePluginElement from "vxe-table-plugin-element";
import "vxe-table-plugin-element/dist/style.css";

VXETable.use(VXETablePluginElement);

// 创建手机号类型单元格渲染
VXETable.renderer.add("phone", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    if (row[column.field]) {
      return (
        <el-tooltip effect="dark" placement="top">
          <span slot="content">{row[column.field]}</span>
          <span>{phoneFilter(row[column.field])}</span>
        </el-tooltip>
      );
    }
  },
});

// 创建身份证类型单元格渲染
VXETable.renderer.add("IDCard", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    if (row[column.field]) {
      return (
        <el-tooltip effect="dark" placement="top">
          <span slot="content">{row[column.field]}</span>
          <span>{IDCardFilter(row[column.field])}</span>
        </el-tooltip>
      );
    }
  },
});

// 创建附件下载类型单元格渲染
VXETable.renderer.add("FileDownloader", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    if (Array.isArray(row[column.field])) {
      return h(
        "div",
        {},
        // 第三个参数
        row[column.field].map((file, index) =>
          h(
            "el-link",
            {
              props: {
                type: "primary",
                download: file.name,
                underline: false,
              },
              style: { display: "block" },
              on:{
                click:()=>{
                  downloadFile({
                    id:file.id,
                    name:file.name
                  })
                }
              }
            },
            "点此下载" + (row[column.field][1] ? index + 1 : "")
          )
        )
      );
    } else return "";
  },
});

// 创建可点击单元格渲染
VXETable.renderer.add("myLink", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    let { events } = renderOpts;
    return (
      <div class="txt-link pointer" onClick={() => events.click(params)}>
        {row[column.field]}
      </div>
    );
  },
});

// 创建操作栏按钮类型单元格渲染
VXETable.renderer.add("OperateLink", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    if (Array.isArray(column.params.buttons)) {
      let { events } = renderOpts;
      return column.params.buttons.reduce((acc, cur) => {
        const vNodeAttrs = {
          props: {
            type: "text",
            status: cur.status || "primary",
            content: cur.content,
          },
          on: {
            click: () => events.click(cur.code, row),
          },
        };
        if (cur.children?.[0]) {
          delete vNodeAttrs.on;
          vNodeAttrs.props.transfer = true;
          vNodeAttrs.style = {
            marginLeft: 0,
          };
          vNodeAttrs.scopedSlots = {
            dropdowns: function () {
              if (cur.children?.[0]) {
                return cur.children.map((child) => {
                  return h("vxe-button", {
                    props: {
                      type: "text",
                      status: child.status,
                      content: child.content,
                    },
                    on: {
                      click: () => events.click(child.code, row),
                    },
                  });
                });
              } else return [];
            },
          };
        }
        const vNode = h("vxe-button", vNodeAttrs);
        if (hasOwn(cur, "visible")) {
          if (typeof cur.visible === "boolean") {
            if (cur.visible) acc.push(vNode);
            return acc;
          }
          if (typeof cur.visible === "function") {
            if (cur.visible(row)) acc.push(vNode);
            return acc;
          }
        } else {
          acc.push(vNode);
          return acc;
        }
      }, []);
    } else return "";
  },
});

// 创建工具栏-左侧按钮渲染
VXETable.renderer.add("ToolbarButton", {
  renderToolbarButton(h, renderOpts, params) {
    const { props, events = {} } = renderOpts;
    const { button } = params;
    let visible = true;
    if (typeof props.visible === "boolean") visible = props.visible;
    if (typeof props.visible === "function") visible = props.visible();
    if (visible) {
      return (
        <vxe-button
          content={props.name}
          status={props.status}
          icon={props.icon}
          onClick={() => {
            events.click(button);
          }}
        />
      );
    }
  },
});

// 可选表格模块
Vue.use(VxeTableFilterModule);
Vue.use(VxeTableEditModule);
// Vue.use(VxeTableMenuModule);
// Vue.use(VxeTableExportModule);
Vue.use(VxeTableKeyboardModule);
// Vue.use(VxeTableValidatorModule);
Vue.use(VxeTableCustomModule);

// 可选组件
Vue.use(VxeIcon);
Vue.use(VxeTable);
Vue.use(VxeColumn);
// Vue.use(VxeColgroup);
Vue.use(VxeGrid);
Vue.use(VxeTooltip);
Vue.use(VxeToolbar);
Vue.use(VxePager);
// Vue.use(VxeForm);
// Vue.use(VxeFormItem);
// Vue.use(VxeFormGather);
Vue.use(VxeCheckbox);
Vue.use(VxeCheckboxGroup);
Vue.use(VxeRadio);
// Vue.use(VxeRadioGroup);
// Vue.use(VxeRadioButton);
Vue.use(VxeSwitch);
Vue.use(VxeInput);
Vue.use(VxeSelect);
// Vue.use(VxeOptgroup);
// Vue.use(VxeOption);
// Vue.use(VxeTextarea);
Vue.use(VxeButton);
// Vue.use(VxeButtonGroup);
// Vue.use(VxeModal);
Vue.use(VxeList);
// Vue.use(VxePulldown);

import XEUtils from "xe-utils/ctor";
import objectEach from "xe-utils/objectEach";
import arrayMethods from "xe-utils/array";
import arrayEach from "xe-utils/arrayEach";
import toArrayTree from "xe-utils/toArrayTree";
import eachTree from "xe-utils/eachTree";
import findTree from "xe-utils/findTree";
import filterTree from "xe-utils/filterTree";
import searchTree from "xe-utils/searchTree";
import filter from "xe-utils/filter";
import some from "xe-utils/some";

XEUtils.mixin(
  //Object
  objectEach,
  // Array
  some,
  filter,
  arrayMethods,
  arrayEach,
  toArrayTree,
  eachTree,
  findTree,
  filterTree,
  searchTree
);

Vue.prototype.XEUtils = XEUtils;
